import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiCrm from './vendors/farlo-ui-crm';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';

((document, window, history) => {
	const pushState = history.pushState;

	// cookie compliance banner
	function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}

			// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let headerHeight = document.querySelector('.site-header').offsetHeight;
	document.documentElement.style.setProperty('--header-height', `${ headerHeight }px`);

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);

	function consoleHover() {
		var toggleButton = document.querySelector('.site-farlo-ui-crm__toggle');
		var consoleDiv = document.querySelector('.console');

		function toggleConsole() {
			consoleDiv.classList.toggle('console--active');
			document.body.classList.add('console--hover');
		}

		// Add class on button click
		toggleButton.addEventListener('click', toggleConsole);

		// Add class on button pseudo-elements hover
		toggleButton.addEventListener('mouseenter', toggleConsole);

		// Remove class on mouse leave
		toggleButton.addEventListener('mouseleave', function () {
			consoleDiv.classList.remove('console--active');
			document.body.classList.remove('console--hover');
		});
	}

	function initCountdowns(selector = '.countdown-timer') {
  document.querySelectorAll(selector).forEach(container => {
    // Read initial values from data- attributes
    const countdown = {
      days:    parseInt(container.dataset.countdownDays,    10) || 0,
      hours:   parseInt(container.dataset.countdownHours,   10) || 0,
      minutes: parseInt(container.dataset.countdownMinutes, 10) || 0,
      seconds: parseInt(container.dataset.countdownSeconds, 10) || 0,
    };

    // Shortcut to the display <p> (should exist for ongoing timers)
    let displayEl = container.querySelector('.countdown-timer__display');

    // Helper: have we reached zero?
    const isEnded = () =>
      countdown.days   <= 0 &&
      countdown.hours  <= 0 &&
      countdown.minutes<= 0 &&
      countdown.seconds<= 0;

    // Swap out the DOM when timer ends
    const handleEnd = () => {
      container.classList.add('countdown--ended');
      // Replace inner HTML entirely
      container.innerHTML = `
        <p class="countdown-timer__ended">
          This event has ended.
        </p>
      `;
    };

    // Refresh the numbers in the display <p>
    const refreshDisplay = () => {
      if (!displayEl) return;
      displayEl.textContent = '';
      // rebuild: "Xd Xh Xm Xs"
      [['days','d'], ['hours','h'], ['minutes','m'], ['seconds','s']]
        .forEach(([key,marker]) => {
          const span = document.createElement('span');
          span.className = 'countdown-timer__unit';
          span.textContent = countdown[key] + marker;
          displayEl.append(span, ' ');
        });
    };

    // On load: if already finished, go straight to end state
    if (isEnded()) {
      handleEnd();
      return;
    }

    // Otherwise, ensure we have a display element
    if (!displayEl) {
      displayEl = document.createElement('p');
      displayEl.className = 'countdown-timer__display';
      container.appendChild(displayEl);
    }
    refreshDisplay();

    // Start the ticking
    const ticker = setInterval(() => {
      // decrement
      if (--countdown.seconds < 0) {
        countdown.seconds = 59;
        if (--countdown.minutes < 0) {
          countdown.minutes = 59;
          if (--countdown.hours < 0) {
            countdown.hours = 23;
            countdown.days--;
          }
        }
      }

      if (isEnded()) {
        clearInterval(ticker);
        handleEnd();
      } else {
        refreshDisplay();
      }
    }, 1000);
  });
}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	function farloUiCrmSignup(_sel) {
		let farloUiSignupForm = null;

		if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
			if (_sel.target.dataset.crmButtonFor !== '') {
				farloUiSignupForm = new FarloUiCrm(_sel.target.dataset.crmButtonFor);
			}
		} else if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiCrm(_sel.id);
		}
	}

	function soundEffect() {

		var button = document.querySelector('.site-farlo-ui-crm__toggle');
		var sound = document.getElementById('hoverSound');
  
		// Play the sound on button click
		button.addEventListener('click', function() {
		  sound.play();
		});
		
	}

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
			}

			if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function elementInView(_sel) {
		const observer = new IntersectionObserver(function(entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('site-farlo-ui-animated--has-animated');
				}
			});
		});

		observer.observe(_sel);
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.console')){
			consoleHover();
		}

		// if (document.querySelector('.hoverSound')){
		// 	soundEffect();
		// }

		if (document.querySelector('.site-farlo-ui-animated')) {
			document.querySelectorAll('.site-farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.countdown-timer__display')){
			initCountdowns();
		}

		if (document.querySelector('.site-farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
